import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import HttpBackend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

import { getEnv } from "@/lib/utils/env"

const env = getEnv()

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "tr",
    lng: env.VITE_DEFAULT_LOCALE,
    supportedLngs: ["tr", "en"],
    defaultNS: "common",
    ns: [
      "common",
      "auth",
      "navigation",
      "devices",
      "alarms",
      "overview",
      "users",
      "partners",
      "dealers",
      "organizations",
      "sites",
      "settings",
      "rules",
      "push-campaigns",
      "hems-ssh-devices",
      "cni-firms",
      "cni-facilities",
      "cni-devices",
      "cni-ssh-devices",
      "cni-users",
      "cni-rbac",
      "cni-audit",
      "cni-overview",
      "cni-packages",
      "cni-licenses",
      "cni-tenants",
      "cni-tariffs",
      "cni-features",
      "cni-scada",
      "support",
    ],
    interpolation: { escapeValue: false }, // React zaten escape ediyor
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "ok.locale",
    },
    react: { useSuspense: true },
  })

export { i18n }
